import script from "./BeyondComparePage.vue?vue&type=script&setup=true&lang=js"
export * from "./BeyondComparePage.vue?vue&type=script&setup=true&lang=js"

import "./BeyondComparePage.vue?vue&type=style&index=0&id=132dd701&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132dd701"]])

export default __exports__